import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SEARCH_TYPES, SEARCH_TABS_RESULT, ISort } from '../models';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';
import { ISortModel } from 'reducers/filters/models';
import { setSort, resetSort } from 'actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { isEmptyError } from 'utilities/validate';
import { searchCBL, resetCBL } from 'actions/cbl';
import { displayFilters } from 'actions/filters';
import { setSortForTable } from 'utilities/tables';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import InPageDialog from '../../../../components/page-dialog';
import { Filters } from 'modules/filters/containers/Filters';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import { searchCBLStatuses, searchProductTypes } from 'constants/statuses';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import { CBLCols } from './models'
import { GeneralTable } from 'modules/search/components/GeneralTable';
import { Search } from '../Search';
import { isFeatureEnabled } from 'utilities/util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';

interface IMapDispatchToProps {
    searchCBL: (pageNumber: number, pageSize: number, genericFilter: string) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
    displayFilters: (hideFilters: boolean, target: string) => void;
    resetCBL: () => void;
}

interface IMapStateToProps {
    isFetchSearchDataLoading: boolean;
    isFetchSearchDataError: boolean;
    searchPendingError: string | string[],
    cbls: any;
	featureToggles: IFeatureToggleModel[];
}

interface IProps extends RouteComponentProps, IMapStateToProps, IMapDispatchToProps { }

interface IState {
    sorted: any[] | ISort[];
    genericFilter: string;
    page: number;
    pageSize: number;
    totalCount: number;
    isFetchinProgress: boolean;
    clearFilters: boolean;
    pendingError: string | string[];
    ETAFrom: boolean,
    ETDFrom: boolean,
    etaFrom: boolean,
    etdFrom: boolean,
    typeOfSearch: string,
    cbl: any[],
    triggerChange: any;
    shouldClear: boolean;
    showDialog: boolean;
    hasData: boolean;
    errorMsg: string | null
}
export class _SearchCBL extends Component<IProps, IState>{
    public generalInputRef: any = React.createRef();
    public tableRef: any = React.createRef();
    public state = {
        sorted: [],
        genericFilter: '',
        page: 1,
        pageSize: 10,
        totalCount: 0,
        clearFilters: false,
        isFetchinProgress: true,
        ETAFrom: false,
        ETDFrom: false,
        etaFrom: false,
        etdFrom: false,
        pendingError: '',
        typeOfSearch: SEARCH_TYPES.CBL,
        cbl: [],
        triggerChange: null,
        shouldClear: false,
        showDialog: false,
        hasData: false,
        errorMsg: ''
    };
    constructor(props: any) {
        super(props);
    }
    public componentDidMount() {
        this.props.displayFilters(false, 'jobCostingCbl')
        this.setState({
            triggerChange: {},
            isFetchinProgress: false,
        })
    }
    public componentDidUpdate(props: any, state: any) {
        if (this.props.isFetchSearchDataError !== props.isFetchSearchDataError) {
            this.setState({
                showDialog: this.props.isFetchSearchDataError,
                isFetchinProgress: false,
                errorMsg: this.props.searchPendingError.toString() ? this.props.searchPendingError.toString() : 'Request Error'
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.props.cbls !== props.cbls) {
            this.setData(this.props.cbls.result, this.props.cbls.page, this.props.cbls.pageSize, this.props.cbls.totalCount)
            this.setState({
                totalCount: this.props.cbls.totalCount
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.props.searchPendingError !== props.searchPendingError &&
            this.props.isFetchSearchDataError === true) {
            const error = isEmptyError(this.props.searchPendingError, 'Server error');
            this.setState({
                pendingError: error,
                isFetchinProgress: false,
                hasData: false
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.state.shouldClear && this.state.shouldClear !== state.shouldClear) {
            this.resetDates()
        }
    }
    public componentWillUnmount(){
        this.props.resetSort()
    }
    public render() {
		const isDCSFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_DCS_EXTRA_DOC, this.props.featureToggles);
		const productTypes = [...searchProductTypes];
		if (isDCSFeatureEnabled) {
			productTypes.push({ optionText: 'DCS', value: 'DCS' });
		}
        return (
            <Search triggerFetch={() => this.targetFetch()}>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.errorMsg}
                    closeMethod={() => this.setState({ showDialog: false, errorMsg: '' })} />
                <Filters
                    tableNameKey="jobCostingCbl"
                    requireFilters={true}
                    genericFilter={this.state.genericFilter}
                    fetchFunction={() => this.fetchReset()}
                    filters={[
                        <FiltersInput
                            key="cblNumber"
                            name="cblNumber"
                            label="CBL Number"
                        />,
                        <FiltersInput
                            key="CarrierBookingReference"
                            name="CarrierBookingReference"
                            id="CarrierBookingReference"
                            label="Carrier Booking Number"
                        />,
                        <FiltersSelect
                            key="status"
                            name="status"
                            id="status"
                            label="Status"
                            options={[
                                ...searchCBLStatuses
                            ]}
                        />,
                        <FiltersSelect
                            key="productType"
                            name="productType"
                            id="productType"
                            label="Product Type"
                            options={[
                                ...productTypes
                            ]}
                        />,
                        <FiltersInput
                            key="loadingPort"
                            name="loadingPort"
                            id="cbl-loadingPort"
                            label="Loading Port"
                        />,
                        <FiltersInput
                            key="dischargePort"
                            name="dischargePort"
                            id="dischargePort"
                            label="Discharge Port"
                        />,
                        <FiltersInput
                            key="ConsigneeBusinessEntityCode"
                            name="ConsigneeBusinessEntityCode"
                            id="ConsigneeBusinessEntityCode"
                            label="Consignee (BE Code)"
                        />,
                        <FiltersInput
                            key="carrierCode"
                            name="carrierCode"
                            id="carrierCode"
                            label="Carrier SCAC Code"
                        />,
                        <FiltersDateInput
                            key="etdFrom"
                            name="etdFrom"
                            id="etdFrom"
                            label="ETD (From)"
                            relatedField="etdTo"
                            setValidity={(val: any) => this.setState({ etdFrom: val })}
                            isInvalid={this.state.etdFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                        <FiltersDateInput
                            key="etdTo"
                            name="etdTo"
                            id="etdTo"
                            label="ETD (to)"
                            minValue="etdFrom"
                            setValidity={(val: any) => this.setState({ etdFrom: val })}
                            isInvalid={this.state.etdFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                        <FiltersDateInput
                            key="etaFrom"
                            name="etaFrom"
                            id="etaFrom"
                            label="ETA (From)"
                            relatedField="etaTo"
                            setValidity={(val: any) => this.setState({ etaFrom: val })}
                            isInvalid={this.state.etaFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                        <FiltersDateInput
                            key="etaTo"
                            name="etaTo"
                            id="etaTo"
                            label="ETA (to)"
                            minValue="etaFrom"
                            setValidity={(val: any) => this.setState({ etaFrom: val })}
                            isInvalid={this.state.etaFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                    ]}
                    resetErrors={() => this.resetDates()}
                    disableSubmit={this.state.etaFrom || this.state.etdFrom}
                    resetPaging={(pageNumber: any, pageSize: any) => {
                        this.updatePagination(1);
                        this.setState({
                            page: 1,
                            totalCount: 0,
                            cbl: [],
                            clearFilters: false,
                            hasData: false
                        })
                    }}
                />
                <TabComponent name="search-results" activeTab={0} navLinks={[SEARCH_TABS_RESULT()[3]]}>
                    <GeneralTable
                        id="jobCosting-search-cbl"
                        cols={CBLCols}
                        data={this.state.cbl}
                        pageCount={Math.ceil(this.props.cbls.totalCount / this.state.pageSize)}
                        isLoading={this.props.isFetchSearchDataLoading}
                        fetchData={this.justFetch}
                        linkAction={(e: any) => {
                            const getId = e.id ? e.id : null;
                            const url = `/job-costing/cbls/${getId}`;
                            this.linkAction(url)
                        }}
                        refFwd={null}
                    /></TabComponent>
            </Search>
        );
    }
    private setData = (data: any, page: number, pageSize: number, totalCount: number) => {
        if (data && data.length) {
            data = data.map((item: any) => {
                if (item.productType === 'BKS' && item.finNumber && item.cblNumber && item.cblNumber.indexOf('/') === -1) {
                    item.cblNumber = `${item.cblNumber}/${item.finNumber}`;
                }
                return item;
            });
        }
        this.setState({
            page,
            pageSize,
            totalCount,
            isFetchinProgress: false,
            hasData: true,
            cbl: data
        })
    }
    private linkAction = (url: string) => {
        return this.props.history.push(url);
    };
    private resetDates = () => {
        if (this.props.cbls && this.props.cbls.result.length > 0) {
            this.props.resetCBL()
        }
        this.setState({
            sorted: [],
            page: 1,
            totalCount: 0,
            ETAFrom: false,
            ETDFrom: false,
            etaFrom: false,
            etdFrom: false,
            isFetchinProgress: true,
            cbl: [],
            clearFilters: true,
            shouldClear: true,
            hasData: false
        })
    };
    private updatePagination = (page: number = this.state.page) => {
        if (this.tableRef && this.tableRef.current && this.tableRef.current.querySelector('input[type=number]')) {
            this.tableRef.current.querySelector('input[type=number]').value = page;
        }
    }
    private targetFetch = (page: number = this.state.page, pageSize: number = this.state.pageSize) => {
        const tempPageSize: any = localStorage.getItem('pageSize-ListTable jobCosting-search-cbl') ?
        localStorage.getItem('pageSize-ListTable jobCosting-search-cbl') : pageSize
        this.setState({
            isFetchinProgress: true,
            pageSize: tempPageSize
        })
        this.props.searchCBL(page, tempPageSize, this.state.genericFilter)
    }
    private fetchReset = (page: number = 1, pageSize: number = 10) => {
        if (!this.state.clearFilters) {
            const p = this.state.page ? this.state.page : page;
            const pS = this.state.pageSize ? this.state.pageSize : pageSize;
            this.setState({
                page: p,
                pageSize: pS,
                isFetchinProgress: true
            });
            this.targetFetch(p, pS)
        }
    };
    private justFetch = (tableData: any) => {
        if (!this.state.isFetchinProgress) {
            let props = {
                page: this.state.page,
                pageSize: this.state.pageSize
            }
            if (tableData) {
                props = {
                    page: tableData.page + 1,
                    pageSize: tableData.pageSize
                }
                this.setState({ sorted: tableData.sorted });
                setSortForTable(tableData.sorted, this.props.setSort)
            } else if (this.state.sorted && this.state.sorted.length) {
                setSortForTable(this.state.sorted, this.props.setSort);
            }
            this.setState({
                page: props.page,
                pageSize: props.pageSize,
                isFetchinProgress: true
            });
            this.targetFetch(props.page, props.pageSize)
        }
        if (tableData) {
            this.setState({
                page: tableData.page + 1,
                pageSize: tableData.pageSize,
            })
        }
    };
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchSearchDataLoading: state.cbl.isFetchDataLoading,
    isFetchSearchDataError: state.cbl.isFetchDataError,
    searchPendingError: state.cbl.detailsPendingError,
    cbls: state.cbl.response,
	featureToggles: state.featureToggle.featureToggles,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    searchCBL: (pageNumber: number, pageSize: number, genericFilter: string) => dispatch(searchCBL(pageNumber, pageSize, genericFilter)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    displayFilters: (hideFilters: boolean, target: string) => dispatch(displayFilters(hideFilters, target)),
    resetCBL: () => dispatch(resetCBL())
});
const __SearchCBL = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_SearchCBL);
export const SearchCBL = withRouter(__SearchCBL);